import { render } from "./OrderLine.vue?vue&type=template&id=3d172902&scoped=true&ts=true"
import script from "./OrderLine.vue?vue&type=script&lang=ts"
export * from "./OrderLine.vue?vue&type=script&lang=ts"

import "./OrderLine.vue?vue&type=style&index=0&id=3d172902&lang=scss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d172902"]])

export default __exports__